import React, { useState, useEffect } from "react";
import Classes from "./Hero2.module.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import backend from "../../../../../../../api";

export default function Hero2({ bookings }) {
  const navigateTo = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchConversations() {
    try {
      const response = await backend.get(`/api/chat/conversation?userId=${user._id}`);
      const convos = (response.data?.data || [])
        .filter((convo) => convo?.last?.text && convo?.last?.text.trim() !== "")
        .slice(0, 3);
      setConversations(convos);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching conversations:", err);
      setError(err.response?.data?.message || "Failed to load messages");
      setLoading(false);
    }
  }

  useEffect(() => {
    if (user._id && user.role === "mentor") {
      fetchConversations();
    }
  }, [user._id, user.role]);

  // Earnings (left as-is)
const totalEarnings =
  bookings?.reduce((sum, b) => {
    if (b?.status === 'Canceled' || b?.status?.label === 'Canceled') {
      return sum; // skip canceled bookings
    }
    return sum + (b.bookingFee || 0);
  }, 0) || 0;
  const earningsThisMonth = bookings
    .filter((b) => {
      const bookingDate = new Date(b.date);
      const now = new Date();
      return (
        bookingDate.getMonth() === now.getMonth() &&
        bookingDate.getFullYear() === now.getFullYear() &&
        b.status.label === "Accepted"
      );
    })
    .reduce((sum, b) => sum + (b.bookingFee || 0), 0);
  const totalMeetingsBooked = bookings?.length || 0;

  // ★ Ratings: count only rated bookings (1–5). If none, show N/A for average.
  const rated = bookings
    .map((b) => Number(b?.rating))
    .filter((r) => Number.isFinite(r) && r >= 1 && r <= 5);

  const ratingsReceived = rated.length || 0;
  const avg = ratingsReceived > 0 ? rated.reduce((a, b) => a + b, 0) / ratingsReceived : null;
  const averageRatingDisplay = avg === null ? "N/A" : `${avg.toFixed(1)}/5`;


  return (
    <div className={Classes.hero}>
      {/* Left column */}
      <div>
        <div className="title">
          <h4>Mentor Summary</h4>
          <hr />
        </div>

        <div className={Classes.box}>
          {/* Earnings */}
          <div className={Classes.boxCon}>
            <h4>Earnings</h4>
            <div className={Classes.flexBetween}>
              <h5>Total Earnings</h5>
              <h4>${totalEarnings.toFixed(2)}</h4>
            </div>
            <div className={Classes.flexBetween}>
              <h5>Earnings This Month</h5>
              <h4>${earningsThisMonth.toFixed(2)}</h4>
            </div>
          </div>

          {/* Activity */}
          <div className={Classes.boxCon}>
            <h4>Activity</h4>
            <div className={Classes.flexBetween}>
              <h5>Total Meetings Booked</h5>
              <h4>{totalMeetingsBooked}</h4>
            </div>
            <div className={Classes.flexBetween}>
              <h5>Average Rating</h5>
              <h4>{averageRatingDisplay}</h4>
            </div>
            <div className={Classes.flexBetween}>
              <h5>Ratings Received</h5>
              <h4>{ratingsReceived}</h4>
            </div>
          </div>
        </div>
      </div>

      {/* Right column */}
      <div>
        <div className="title">
          <div>
            <h4>Recent Messages</h4>
            <h5
              onClick={() => navigateTo("/messages")}
              style={{ color: "#e15757", cursor: "pointer" }}
            >
              View all
            </h5>
          </div>
          <hr />
        </div>

        <div className={Classes.box}>
          {loading ? (
            <div className={Classes.center} >
              <h5 className="placeholderText" >Loading...</h5>
            </div>
          ) : <>
            {conversations && conversations.length > 0 ? (
              <ul className={Classes.messageList}>
                {conversations.map((convo) => (
                  <li key={convo._id} className={Classes.messageItem}>
                    <img
                      src={convo.partnerAvatar || "https://i.pravatar.cc/80"}
                      alt={convo.partnerName}
                      className={Classes.avatar}
                    />
                    <div className={Classes.messageBody}>
                      <h5 className={Classes.name}>{convo.partnerName || "Unknown"}</h5>
                      <h5 className={Classes.snippet}>{convo.last.text}</h5>
                      <h5 className={Classes.time}>
                        {new Date(convo.last.createdAt).toLocaleString([], {
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </h5>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <div className={Classes.emptyMessage} >
                <img src='/assets/images/empty-message.png' alt="empty" draggable={false} />
                <h5>No recent messages</h5>
              </div>
            )}
          </>
          }

        </div>

      </div>
    </div>
  );
}
